import { useComposedRefs } from '@radix-ui/react-compose-refs'
import { forwardRef, useContext } from 'react'

import { AppBarContext } from './context'

export type AppBarStickyTriggerElement = HTMLDivElement
export type AppBarStickyTriggerProps = React.HTMLAttributes<AppBarStickyTriggerElement>

const AppBarStickyTrigger = forwardRef<AppBarStickyTriggerElement, AppBarStickyTriggerProps>(
  function AppBarStickyTrigger(props, forwardedRef) {
    const ctx = useContext(AppBarContext)
    const refs = useComposedRefs(forwardedRef, ctx.stickyTriggerRef)
    return <div {...props} ref={refs} />
  }
)

export default AppBarStickyTrigger
